import React from 'react';
import { useTranslation } from 'react-i18next';
import { TechPartner } from '@/components/tech-partner';

export const Partners: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full py-10 relative dark:bg-slate-800">
      <div className="max-w-[95%] 2xl:max-w-[85%] mx-auto px-4">
        {/* Text content */}
        <div className="max-w-4xl mx-auto mb-12 text-center px-4">
          <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-3 tracking-tight">
            {t('partners.technologiesBanner', 'Technologies Partners')}
          </h3>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {t('partners.technologiesSubtitle', 'Powered by industry-leading technologies and partnerships')}
          </p>
        </div>
        
        <TechPartner />
      </div>
    </section>
  );
};